export const formatError = (err: string | Object | undefined) => {
  if (err && typeof err !== 'string') {
    return Object.values?.(err).join(', ');
  } else {
    return err;
  }
};
